"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationList = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var framer_motion_1 = require("framer-motion");
var react_1 = __importDefault(require("react"));
var context_1 = require("../context");
var notification_item_1 = require("./notification-item");
function NotificationList() {
    var notifications = (0, context_1.useNotifications)().entries;
    return (react_1.default.createElement("div", { style: {
            position: 'fixed',
            zIndex: core_ui_1.zIndices.notifications,
            bottom: 16,
            left: '50%',
            transform: 'translate(-50%, 0)',
        } },
        react_1.default.createElement(framer_motion_1.AnimatePresence, { initial: false }, notifications.map(function (notification) { return (react_1.default.createElement(framer_motion_1.motion.div, { key: notification.id, initial: { opacity: 0, y: 50, scale: 0.3 }, animate: { opacity: 1, y: 0, scale: 1 }, exit: { opacity: 0, scale: 0.5, transition: { duration: 0.2 } } },
            react_1.default.createElement(notification_item_1.NotificationItem, { key: notification.id, id: notification.id, notification: notification.data }))); }))));
}
exports.NotificationList = NotificationList;
